import React, {Component} from 'react';
import Action from 'components/organisms/used-players-list/actions';
import Const from 'constants';
import {getModesConfig} from 'helpers/modes-config';
import InputRadio from 'components/atoms/inputs/input-radio';

class BaseFilterComponent extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('FilterSingleGame', value));
    }

    prepareTabs() {
        const {sportConfig, filters} = this.props;

        const tabs = [
            <label className="tabs-chk" key={Const.OVERALL_MODE}>
                <InputRadio
                    value={Const.OVERALL_MODE}
                    checked={Const.OVERALL_MODE === filters.singleGame}
                    onChange={::this.onChange}
                />
                <span>All</span>
            </label>,
        ];

        const modesConfig = getModesConfig(sportConfig);
        Object.values(modesConfig).map((mode, i) => {
            tabs.push(
                <label className="tabs-chk" key={i}>
                    <InputRadio
                        value={mode.getRole()}
                        checked={mode.getRole() === filters.singleGame}
                        onChange={::this.onChange}
                    />
                    <span>{mode.getLabel()}</span>
                </label>,
            );
        });

        return tabs;
    }
}

export {BaseFilterComponent};
